import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import qs from "qs"
export default new Vuex.Store({
  state: {
    // scenicId: "c0ba1ab7e9104b288859389fe6d774ba ", //小图uuid
    scenicId: "c0ba1ab7e9104b288859389fe6d774ba", //小图uuid
    //scenicId: "65b3862755cf449bad6d9af7bd734ce8", //小图uuid
    // scenicId: '81f5c1f41fe8431ebcba32e7755dff0f',//大图uuid
    showType: 1,
    userid: "123",
    map: "", //全局地图map
    //content: "",
    scenicScopeBd: [], //百度坐标 手绘图范围框 判断在景区内的范围框
    scenicScope: [], //腾讯/高德坐标 手绘图范围框 判断在景区内的范围框
    minZoomlevel: '', //最小缩放级别
    maxZoomlevel: '', //最大缩放级别
    currentLevel: "", //当前缩放级别
    facilities: [], //设施点
    smallMarker: [], //小景点 sc+ssc
    smallMarkerTag: [], //tag
    smallMarkerSsc:[],//二级景区
    smallMarkerSc:[],//小景点一级景区marker点
    legEndcontent: [], //传说列表
    linesData: "", //路线
    disLevel: 0, // 点聚合的聚合范围
    drawUrl: "",
    currenntPlayIndex: -1, //初始化值
    currentLegEndPlayIndex: -1, //传说初始化播放index
    isAudioPlay: false, //当前音频是否播放
    isAudioStop: false, //当前音频是否播放完毕
    isSmallMarkerImg: false, //列表点击不弹出小景点图/marker点点击弹出小景点图
    isScenicListOrLegend: 0, // 0 景点列表传说列表都不展示 1 景点列表展示  2 传说列表展示
    isLegendOrscenicShow: true, // false 展示 传说 true展示 小景点
    isLegEndIconShow: false, //false 传说按钮灰色  true 传说按钮高亮
    isScenicListIconShow: false, //false 景点列表按钮灰色  true 传说按钮高亮
    isAudioList: false, //语音列表展示
    isContinuousPlay: false, //是否连续播放
    isScenicContinuousPlay:false,
    isLegendContinuousPlay:false,
    isPlayScenicOrLegend: true, //true当前为小景点播放false 当前为传说播放
    currentDuration: 0, //当前总时长
    currentTime: 0, //当前播放时长
    centreLat:0,
    centreLng:0,
    currentLng: 0, //当前经度
    currentLat: 0, //当前纬度
    isInscenicArea: true, //true 在景区内  false 不在景区内
    isInscenicPopUp: false,
    isAutoGuide: false, //自动按钮true为开启自动导览 false 为关闭自动导览
    isClickListOrMarker: false, //false点击的是marker true点击的是列表
    isNotifyShow: false, //新景点名称弹出
    isActivate: -1, //是否激活初始值
    isNewScenicIndex: -1, //进入新景点索引值
    subDetails: "", //是否有局部按钮
    isUnfoldSubDetails: false,
    sourceType: "",
    access_token: "",
    isLocationSuccess: false,
    isVisibility: false, //暂停状态/播放状态
    circleNum: 0,
    helpShowFlag: false,
    isAndroidOrIos:'ios',
    isLineOrScenic:true,//true为点击小景点  false 为点击路线
    timerNum:0,
    lineClass:"",
    markerPlayedArr:[],
    prevPlayIndex:-1,
    visibleIcon:true,//导览页图标 点击地图展示消失
    isAudioPause:false//false 自动暂停 true 手动暂停

  },
  getters: {},
  mutations: {

  },
  actions: {

  },
  modules: {}
})
